import React, { MouseEvent } from 'react';
import { IconButton } from '@mui/material';
import { MoreHoriz } from '@mui/icons-material';
import ModuleCard from 'components/module-card/ModuleCard';
import { Guide } from 'types/guide';
import { useReportGuide } from '../../hooks/useReportGuide';

interface ReportGuideItemModuleProps {
  guide: Guide;
}

function getStatusTone(status: string) {
  if (status === 'scheduled') return 'info';
  if (status === 'completed') return 'success';
  if (status === 'deleted') return 'error';
  if (status === 'no_show') return 'warning';
  return 'default';
}

const ReportGuideItemModule: React.FC<ReportGuideItemModuleProps> = ({ guide }) => {
  const { setAnchorEl, setSelectedGuide } = useReportGuide();

  function handleActionClick(event: MouseEvent<HTMLButtonElement>) {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
    setSelectedGuide(guide);
  }

  return (
    <ModuleCard
      idLabel={`Guia #${guide.id}`}
      title={guide.formattedPatientName}
      subtitle={guide.formattedProcedureName}
      status={guide.formattedStatus}
      statusTone={getStatusTone(guide.status)}
      actions={
        <IconButton size="small" color="default" onClick={handleActionClick}>
          <MoreHoriz fontSize="small" />
        </IconButton>
      }
      fields={[
        { label: 'Geração', value: guide.formattedCreatedAt },
        { label: 'Consulta', value: guide.formattedAppointmentDate },
        { label: 'Parceiro', value: guide.formattedDoctorName },
        { label: 'Marcador', value: guide.formattedMarkerName },
        { label: 'Forma de pagamento', value: guide.formattedPaymentMethods, fullWidth: true },
        { label: 'Procedimento', value: guide.formattedProcedureName, fullWidth: true },
      ]}
      metrics={[
        { label: 'Custo', value: guide.formattedValueCost },
        { label: 'Venda', value: guide.formattedValueProcedure },
        {
          label: 'Desconto',
          value: guide.formattedValueDiscount,
          tone: guide.value_discount > 0 ? 'error' : 'default',
        },
        { label: 'Total', value: guide.formattedValueTotal, tone: 'primary' },
      ]}
    />
  );
};

export default ReportGuideItemModule;
